module.exports = __webpack_public_path__ + "img/btn_right@3x.5396fe74.png";